import Vue from "vue";
import { Row, Column, Hidden } from "vue-grid-responsive";

Vue.component("row", Row);
Vue.component("column", Column);
Vue.component("hidden", Hidden);
